import { render, staticRenderFns } from "./DefectDetailPopup.vue?vue&type=template&id=676ad359&scoped=true&"
import script from "./DefectDetailPopup.vue?vue&type=script&lang=js&"
export * from "./DefectDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./DefectDetailPopup.vue?vue&type=style&index=0&id=676ad359&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676ad359",
  null
  
)

export default component.exports